import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  DialogContent,
  Dialog,
  styled,
} from "@mui/material";
import BaseLineUploadGif from "./../../Assests/Kibon GIF.mp4";
import { baseLineUploadingDone } from "./../../Redux/Actions/InputData";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BaseLineUploading(props: any) {
  const dispatch = useDispatch();

  const [baseLineUploadingTime, setBaseLineUploadingTime] = useState(0);
  const VIDEO = {
    src: BaseLineUploadGif,
    type: "video/mp4",
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setBaseLineUploadingTime((oldProgress) => {
        if (oldProgress === 100) {
          dispatch(baseLineUploadingDone());
          props.closeBaseLineUploader(false)
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, []);


  return (
    <>
      <BootstrapDialog
        onClose={props.closeBaseLineUploader}
        aria-labelledby="customized-dialog-title"
        open={props.isOpenBaseLineUploader}
      >
        <DialogContent className="modal-body">
          <div className="baseLineUploading">
            <video autoPlay loop width="400" height="300">
              <source src={VIDEO.src} type="video/mp4" />
              <img src={VIDEO.src} width="400" height="300" />
            </video>
            <h6>Please wait...</h6>
            <p>
              Optimising your Baseline data to provide you the Best scenario
              cost using ML model.
            </p>
          </div>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
}

export default BaseLineUploading;
